import { Button, Checkbox, Fieldset, Stack, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { samplingApi } from '../../data-access/apis/sampling';

import { useOrderPointsSelectionStore } from '../tables/order-points-table';

interface ManagePointsFormProps {
  orderId: number;
}

export const ManagePointsForm = ({ orderId }: ManagePointsFormProps) => {
  const { t } = useTranslation();
  const pointsSelection = useOrderPointsSelectionStore(
    (state) => state.rowSelection,
  );
  const setRowSelection = useOrderPointsSelectionStore(
    (state) => state.setRowSelection,
  );
  const selectedPoints = Object.keys(pointsSelection);

  const update = useMutation({
    mutationFn: samplingApi.orders.updatePoints,
  });

  const form = useForm({
    initialValues: {
      cancel: false,
      add_in_new_command: false,
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    if (selectedPoints.length === 0) return;
    update.mutate(
      {
        commandId: orderId,
        data: {
          ids: selectedPoints,
          ...values,
        },
      },
      {
        onSuccess: () => {
          form.reset();
          setRowSelection({});
        },
      },
    );
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Title mb="md" order={3}>
        {t('common.gerer-des-points')}
      </Title>
      <Fieldset disabled={selectedPoints.length === 0} variant="unstyled">
        <Stack>
          <Checkbox
            label={t('common.annuler-le-point')}
            {...form.getInputProps('cancel', { type: 'checkbox' })}
          />
          <Checkbox
            label={t('common.ajouter-le-point-dans-une-nouvelle-commande')}
            {...form.getInputProps('add_in_new_command', { type: 'checkbox' })}
          />
        </Stack>
      </Fieldset>
      <Button
        disabled={selectedPoints.length === 0}
        loading={update.isPending}
        mt="md"
        type="submit"
      >
        {t('common.save')}
      </Button>
    </form>
  );
};
